import { unaryStreamRpc } from "@redotech/rpc/definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";
import { AskRedoStreamEventSchema } from "./stream-ask-redo";

/**
 * Streams a buffered turn: a `turn` status first, then events to `complete`/`error`.
 * No `turnId`: the running turn from its start, or `complete` when none runs.
 */
export const watchAskRedoTurn = unaryStreamRpc({
  name: "watchAskRedoTurn" as const,
  input: z.object({
    threadId: zExt.objectId(),
    turnId: z.string().optional(),
    cursor: z
      .number()
      .int()
      .min(0)
      .optional()
      .describe("Index of the next turn event to send; only with turnId."),
  }),
  output: AskRedoStreamEventSchema,
});
